import { AnalyticsService } from 'src/app/services/analytics.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Location, DatePipe } from '@angular/common';
import { AppConstant } from 'src/app/utilities/app.constants';
import { CustomDialogService } from 'src/app/shared/custom-dialog.service';
import { ActivatedRoute } from '@angular/router';
import { AppSpinnerService } from 'src/app/services/app-spinner.service';
import html2canvas from 'html2canvas'; 
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import { SettingsService } from './../../../../services/settings.service';


@Component({
  selector: 'app-safety-rating-feedback',
  templateUrl: './safety-rating-feedback.component.html',
  styleUrls: ['./safety-rating-feedback.component.scss']
})
export class SafetyRatingFeedbackComponent implements OnInit {

  @ViewChild('safetyratingfeedback', { static: false }) safetyratingfeedback: ElementRef;
  safetyRating: any;
  safetyRatingDetails: any;
  crewMemberRank = '';
  submitterCrewId = '';
  submitterRank = '';
  submitterName = '';
  safetyRatingDetailView = false;
  submitterProfileImage = '';
  crewUserName: '';
  ratingDataArray = ["Unsatisfactory","Needs Imporvement","Meets Expectations","Exceeds Expectations","Exceptional"];
  constructor(
    private location: Location,
    private readonly analyticsService: AnalyticsService,
    private readonly customDialogService: CustomDialogService,
    private readonly activatedRoute: ActivatedRoute,
    public appSpinner: AppSpinnerService,
    public datepipe: DatePipe,
    private settingsService: SettingsService
    ) { }

  ngOnInit() {
    this.getSubmitterDetailSetting();
    // const ratingMasterId =  this.activatedRoute.snapshot.paramMap.get('ratingMasterId');
    let ratingMasterId = ''; 
    this.activatedRoute.queryParams.subscribe(params => {
      ratingMasterId = params["Id"];
      this.crewMemberRank = params["rank"];
  });
    console.log('ratingMasterId',ratingMasterId);
    this.fetchSafetyRatingDetails(ratingMasterId);
  }

  fetchSafetyRatingDetails(ratingId: string) {
    this.appSpinner.show();
    this.analyticsService.getRatingDetails(ratingId).subscribe((ratingDetails: []) => {
      this.safetyRatingDetails = ratingDetails;
      this.safetyRating = this.safetyRatingDetails[0];
      this.safetyRating.userId.rank = this.crewMemberRank;
      this.crewUserName = this.safetyRating.userId.firstName;
  
      //setting the submitter Details
      this.submitterCrewId = this.safetyRatingDetails[0].ratingMasterId.submitterDetails.crewId;
      this.submitterRank = this.safetyRatingDetails[0].ratingMasterId.submitterDetails.rank;
      this.submitterName = this.safetyRatingDetails[0].ratingMasterId.submitterDetails.name;
      this.submitterProfileImage = this.safetyRatingDetails[0].ratingMasterId.submitterDetails.imageBase64;
      this.appSpinner.hide();
    });
    
  }

  // replaceLineBreak(ratingLabel: string) {
  //   return ratingLabel.split('.')[1].replace('<br>', ' ');
  // }

  getSubmitterDetailSetting(){
    this.settingsService.getSubmitterDetailViewStatus().subscribe((data : any) => {
      if(data){
        this.safetyRatingDetailView = data.showSubmitterDetail;
      }
    })
  }
 
addHeaderFooter(doc: jsPDF) {

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const pageCount = doc.getNumberOfPages();

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);

    const footerY = pageHeight - 15;

    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
   // doc.text('Ardmore Shipping', 10, footerY);

    doc.setFont('helvetica', 'normal');
    doc.text(
      `Downloaded on Date: ${this.formatDate(new Date())}`,
      pageWidth / 2 - 25,
      footerY
    );

    doc.text(
      `Page ${i}/${pageCount}`,
      pageWidth - 30,
      footerY
    );
  }
}
formatDate(date: any): string {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

replaceLineBreak(rating: number): string {
  switch (rating) {
    case 1: return 'Unsatisfied';
    case 2: return 'Needs Improvements';
    case 3: return 'Meets Expectations';
    case 4: return 'Exceeds Expectations';
    case 5: return 'Exceptional';
    default: return '-';
  }
}


  goBack() {    
    this.location.back();
    this.analyticsService.isChartView = false;
  }

onAddPDF() {

  const doc = new jsPDF('p', 'mm', 'a4');

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // -----------------------------
  // HEADER
  // -----------------------------

  const logoWidth = 15;
  const logoHeight = 15;

  // Header Logo (LEFT)
  doc.addImage(AppConstant.IMG_HEADER, 'PNG', 10, 3, logoWidth, logoHeight);

  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('Safety Rating Analytics', 30, 12);

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('Analytics', pageWidth - 25, 15);

  doc.setLineWidth(0.3);
  doc.line(10, 20, pageWidth - 10, 20);

  // -----------------------------
  // TITLE
  // -----------------------------

  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text(
    `Crew Rating Feedback on ${this.formatDate(this.safetyRating.createdAt)}`,
    pageWidth / 2,
    30,
    { align: 'center' }
  );

  // -----------------------------
  // CREW DETAILS BLOCK
  // -----------------------------

  const startY = 40;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('Crew ID :', 10, startY);
  doc.text('Name :', 10, startY + 8);
  doc.text('Rank :', 10, startY + 16);

  doc.text('Vessel :', pageWidth / 2, startY);
  doc.text('Safety Rating :', pageWidth / 2, startY + 8);

  doc.setFont('helvetica', 'normal');

  doc.text(this.safetyRating.crewId || '-', 30, startY);
  doc.text(
    (this.safetyRating.userId.firstName + ' ' + this.safetyRating.userId.anotherName) || '-',
    30,
    startY + 8
  );
  doc.text(this.safetyRating.userId.rank || '-', 30, startY + 16);

  doc.text(this.safetyRating.vesselName || '-', pageWidth / 2 + 35, startY);
  doc.text(
    String(this.safetyRating.ratingMasterId.finalRating || '-'),
    pageWidth / 2 + 45,
    startY + 8
  );

  // Divider line
  doc.line(10, startY + 22, pageWidth - 10, startY + 22);

  // -----------------------------
  // TABLE DATA (Questions + Ratings)
  // -----------------------------

  const tableBody = this.safetyRatingDetails.map(r => {
    return [
      r.question,
      this.replaceLineBreak(r.rating)  // your method: 1..5 -> Unsatisfied..Exceptional
    ];
  });

  autoTable(doc, {
    startY: startY + 28,
    head: [['Questions', 'Ratings']],
    body: tableBody,
    styles: {
      fontSize: 9,
      cellPadding: 3
    },
    headStyles: {
      fillColor: [240, 240, 240],
      textColor: 0,
      fontStyle: 'bold'
    },
    columnStyles: {
      0: { cellWidth: 140 }, // Questions column
      1: { cellWidth: 40 }   // Ratings column
    },
    didDrawPage: (data) => {
      this.addHeaderFooter(doc);
    }
  });

  let finalY = (doc as any).lastAutoTable.finalY || 200;

  // -----------------------------
  // COMMENTS SECTION
  // -----------------------------

  doc.setFont('helvetica', 'bold');
  doc.text('Comments:', 10, finalY + 10);

  doc.setFont('helvetica', 'normal');
  const commentText = this.safetyRating.ratingMasterId.comment || '-';
  const splitComments = doc.splitTextToSize(commentText, pageWidth - 20);
  doc.text(splitComments, 10, finalY + 18);

  finalY = finalY + 18 + splitComments.length * 5;

  // -----------------------------
  // RATING SCALE SECTION
  // -----------------------------

  doc.setFont('helvetica', 'bold');
  doc.text('Rating Scale:-', 10, finalY + 12);

  doc.setFont('helvetica', 'normal');
  const scale = [
    '1 : Unsatisfied',
    '2 : Needs Improvements',
    '3 : Meets Expectations',
    '4 : Exceeds Expectations',
    '5 : Exceptional'
  ];

  scale.forEach((line, index) => {
    doc.text(line, 10, finalY + 20 + index * 6);
  });

  // -----------------------------
  // FOOTER (on all pages)
  // -----------------------------

  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);

    const footerY = pageHeight - 15;
 // Footer Logo (LEFT)
    doc.addImage(AppConstant.IMG_FOOTER, 'PNG', 10, footerY - 10, 50, logoHeight);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
   // doc.text('Ardmore Shipping', 10, footerY);

    doc.setFont('helvetica', 'normal');
    doc.text(
      `Downloaded on Date: ${this.formatDate(new Date())}`,
      pageWidth / 2 - 25,
      footerY
    );

    doc.text(
      `Page ${i}/${pageCount}`,
      pageWidth - 30,
      footerY
    );
  }

  // -----------------------------
  // SAVE PDF
  // -----------------------------

  doc.save('Crew-Rating-Feedback.pdf');
}


    
  addHeaderAndFooter(pdfObject,crewobj) {
    const date = this.datepipe.transform(this.safetyRating.createdAt, 'dd/MM/yyyy');
    var number_of_pages = pdfObject.internal.getNumberOfPages();
    var pdf_pages = pdfObject.internal.pages;
    var report_name = 'Crew Rating Feedback'+ ' on ' +date;
    const todayDate = new Date();
    const currentDate = this.datepipe.transform(todayDate, 'dd/MM/yyyy');
    for (var i = 1; i < pdf_pages.length; i++) {
      // We are telling our pdfObject that we are now working on this page
      pdfObject.setPage(i);
      pdfObject.text(currentDate, 175, 270);
      pdfObject.text(crewobj.crewId, 24, 40);
			pdfObject.text(crewobj.crewName, 21, 50);
      pdfObject.text(crewobj.Rank, 20, 60);
      pdfObject.text(crewobj.vesselName, 99, 60);
      pdfObject.text(crewobj.avgRating, 196, 60);
      pdfObject.setFontType('bold');
      pdfObject.text('Downloaded on Date:', 127, 270);
      pdfObject.text('Analytics',175, 15);
      pdfObject.text(report_name,65,30);
      pdfObject.text('Crew ID :',5, 40);
			pdfObject.text('Name :',5, 50);
			pdfObject.text('Rank :',5, 60);
			pdfObject.text('Vessel :',80,60);
			pdfObject.text('Safety Rating :',162,60);
      pdfObject.text(AppConstant.HEADER_TEXT,22, 15);
      pdfObject.addImage(AppConstant.IMG_HEADER, 'png', 5, 7, 15, 15);
      pdfObject.addImage(AppConstant.IMG_FOOTER, 'png', 5, 280, 60, 15);
      pdfObject.text('Page ' + i + '/' + number_of_pages, 
      pdfObject.internal.pageSize.getWidth() - 30, pdfObject.internal.pageSize.getHeight() - 10);
    }
  }

  addRatingDescription(pdfObject) {
    var number_of_pages = pdfObject.internal.getNumberOfPages();
    var pdf_pages = pdfObject.internal.pages;
    for (var i = 1; i < pdf_pages.length; i++) {
      if (i == number_of_pages) {
        pdfObject.setFontSize(10)
        pdfObject.setFontType('unbold');
        pdfObject.text(' Unsatisfied', 10, 195);
        pdfObject.text(' Needs Improvements', 10, 200);
        pdfObject.text(' Meets Expectations', 10, 205);
        pdfObject.text(' Exceeds Expectations', 10, 210);
        pdfObject.text(' Exceptional', 10, 215);
        pdfObject.setFontType('bold');
        pdfObject.text('Rating Scale:-', 5, 190);
        pdfObject.text('1 :', 5, 195);
        pdfObject.text('2 :', 5, 200);
        pdfObject.text('3 :', 5, 205);
        pdfObject.text('4 :', 5, 210);
        pdfObject.text('5 :', 5, 215);
      }
    }
  }

  submitterDetailsDialogue(){
    const msg = `Submitted By:`;
    this.customDialogService.setSubmitterImage(this.submitterProfileImage);
    this.customDialogService.showSubmitterDetailsDialogue(msg,this.submitterCrewId,this.submitterName,this.submitterRank,'dismiss');
  }

}
